module.exports = __webpack_public_path__ + "static/img/xinlvyao.36bb734f.png";